<div class="row">
    <div class="col-xl-12">
        <form [formGroup]="payOutstandingForm" (ngSubmit)="onSubmit()" (reset)="onReset()">
            <table class="table mb-0 table-bordered table-borderless create-evse">
                <tbody class="border-none">
                    <tr>
                        <td>Use wallet balance <br>Available {{currencySymbol}} {{walletAmount}}</td>
                         <td>
                            <div class="custom-control custom-checkbox" >
                                 <input formControlName="useWalletBalance" type="checkbox" class="custom-control-input" id="useWalletBalance" [attr.disabled]="walletAmount<=0 ? true : null">
                                <label class="custom-control-label" for="useWalletBalance" ></label>
                            </div>
                        </td> 
                    </tr>
                    <tr>
                        <td>
                            Reason
                        </td>
                        
                        <td>
                            <input type="text" formControlName="reason" class="form-control" />
                            <!-- <span class="text-danger pt-2 float-left" *ngIf="(stopSessionForm.controls.reason.touched || submitted) && stopSessionForm.controls.reason.errors?.required">
                                Reason is required.
                            </span> -->
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="mt-3 text-center">
                            <div class="d-inline">
                                <input type="submit" class="btn btn-hes mr-3" value="Submit">
                                <input type="reset" class="btn btn-danger" value="Cancel">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
</div>